import { createFileRoute, redirect } from "@tanstack/react-router";

/** ALP-84: short / renamed URL → its page (see REDIRECTS in app/nav.ts). */
export const Route = createFileRoute("/_app/calendar")({
  beforeLoad: () => {
    throw redirect({ to: "/content", replace: true });
  },
});
